import React from 'react';
import { Section } from '../ui/Section';
import { Accordion } from '../ui/Accordion';
export function FAQ() {
  const faqs = [{
    title: '¿Cómo recibo el material después de comprar?',
    content: 'Inmediatamente después de procesado el pago, vas a recibir un correo electrónico con un link de acceso directo para descargar todos los tomos y bonos en formato PDF digital. Podés guardarlos en tu computadora, tablet o celular.'
  }, {
    title: '¿Sirve si tengo consultorio chico o recién estoy empezando?',
    content: 'Absolutamente. De hecho, es el mejor momento para implementarlo. Organizar los procesos desde el día uno evita que arrastres vicios administrativos y te permite escalar tu práctica de forma ordenada.'
  }, {
    title: '¿Necesito algún software especial para usar las plantillas?',
    content: 'No. Todas las plantillas están diseñadas para usarse con herramientas que ya tenés (Excel, Word, Google Sheets/Docs) o incluso para imprimirlas y completarlas a mano si preferís el papel.'
  }, {
    title: '¿Los 3 bonos están incluidos en ambas ofertas?',
    content: 'Sí, tanto si elegís el Kit Esencial como el Megapack Completo, te llevás los 3 bonos estratégicos sin costo adicional.'
  }, {
    title: '¿Sirve si trabajo también en relación de dependencia además de mi consultorio?',
    content: 'Sí. Muchos oncólogos dividen su tiempo. Este sistema te ayuda a que las horas que le dedicás a tu consultorio privado sean 100% eficientes y no se superpongan con tus otras responsabilidades.'
  }, {
    title: '¿Este material reemplaza a mi contador o abogado?',
    content: 'No. Es un sistema de organización y gestión administrativa. Para cuestiones impositivas, contables o legales específicas, siempre tenés que consultar con tu contador o abogado matriculado.'
  }, {
    title: '¿Qué diferencia tiene con armar mis propias planillas?',
    content: 'El tiempo y la experiencia. Podés armarlas vos, pero te llevaría meses de prueba y error llegar a un sistema que realmente funcione. Acá te llevás el atajo: herramientas probadas y listas para usar hoy mismo.'
  }, {
    title: '¿Por qué elegir el Megapack y no el Kit Esencial?',
    content: 'El Megapack incluye los módulos de Facturación e Indicadores. Si querés dejar de adivinar cuánto ganás y empezar a tratar tu consultorio como un negocio rentable con datos reales, el Megapack es la opción indicada.'
  }, {
    title: '¿Tiene garantía real?',
    content: 'Sí. Tenés 7 días desde la compra. Si sentís que el material no te aporta valor, nos mandás un mail y te devolvemos el 100% del dinero, sin vueltas.'
  }];
  return <Section className="bg-white" data-id="element-74">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-75">
        <div className="text-center mb-8 md:mb-12" data-id="element-76">
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-2 md:mb-4" data-id="element-77">
            DUDAS COMUNES
          </h2>
          <p className="text-lg md:text-xl text-slate-600" data-id="element-78">
            Preguntas Frecuentes
          </p>
        </div>

        <Accordion items={faqs} data-id="element-79" />
      </div>
    </Section>;
}